<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/goals-icon.svg" alt=""></div>
            <div>
                <h4 class="text-semibold">Nueva Meta</h4>
                <h6 class="color-gray" style="font-weight: 400;">Completa los datos para registrar una nueva meta</h6>
            </div>
            <div>
                <h3 class="color-gray text-semibold">
                    <div class="center-svg">
                        <img (click)="closeMdl()"  class="close-button" src="assets/svg/close-icon.svg" alt="">
                    </div>
                </h3>
            </div>
    </div>

    <div class="mdl-body">
        <h5 class="text-semibold mt-4">Información de la meta</h5>

      <form #GoalsForm="ngForm" (ngSubmit)="$event.preventDefault()">
      <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
        <div>
        <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!request.descripcion || request.descripcion.trim()===''">*</span>
              Descripción de la meta
            </label>
            <input
             class="crm-input"
              type="text"
              name="descripcion"
               [(ngModel)]="request.descripcion"
               required
               #descripcion="ngModel">
               <div class="error-text" *ngIf="descripcion.invalid && (descripcion.dirty || descripcion.touched)">
                <small *ngIf="descripcion.errors?.['required']"> El campo Descripción es obligatorio</small>
               </div>
        </div>
        <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!request.fecha_inicio || request.fecha_inicio.trim()===''">*</span>
              Fecha de inicio
            </label>
            <input 
            class="crm-input" 
            type="date" 
            name="fecha_inicio"
            [(ngModel)]="request.fecha_inicio"
            required
            #fechaInicio="ngModel">
            <div class="error-text" *ngIf="fechaInicio.invalid && (fechaInicio.dirty || fechaInicio.touched)">
              <small *ngIf="fechaInicio.errors?.['required']"> El campo Fecha de inicio es obligatorio</small>
            </div>

        </div>
            <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!selectedUsers || selectedUsers.length === 0">*</span> Asignar meta a:
            </label>
            <div class="d-flex gap-20 align-items-start mt-3">
              <div class="flex-1">
                <ng-select class="crm-ng-select"
                  [items]="users"
                  name="usuario_id"
                  bindLabel="nombreCompleto"
                  bindValue="usuario_id"
                  [multiple]="true"
                  [(ngModel)]="selectedUsers"
                  placeholder="Buscar usuarios...">
                </ng-select>
              </div>

              <div class="selected-users-list d-flex gap-10 flex-wrap">
                <div class=" crm-input user-card white-card d-flex align-items-center gap-6"
                  *ngFor="let userId of selectedUsers">
                  <div class="d-flex align-items-center gap-10">
                    <img class="contact-avatar" src="assets/svg/user-icon.svg" alt="user">
                    <span class="login-label">{{ getUserName(userId) }}</span>
                  </div>
                  <div>
                  <img  class="close-icon" src="assets/svg/x-icon.svg" (click)="removeUser(userId)" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div>
            <div class="mt-3">
                <label 
                class="login-label">
                <span class="required-asterisk" *ngIf="!request.valor_objetivo">*</span>
                Valor objetivo
              </label>
                <input 
                class="crm-input" 
                type="number"
                min="0" 
                name="valor_objetivo"
                [(ngModel)]="request.valor_objetivo"
                required
                #valorObjetivo="ngModel">
                <div class="error-text" *ngIf="valorObjetivo.invalid && (valorObjetivo.dirty || valorObjetivo.touched)">
                  <small *ngIf="valorObjetivo.errors?.['required']"> El campo Valor objetivo es obligatorio</small>
                </div>
            </div>
            <div class="mt-3">
                <label class="login-label">
                  <span class="required-asterisk" *ngIf="!request.fecha_fin || request.fecha_fin.trim()==='' ">*</span>
                  Fecha de cierre
                </label>
                <input 
                class="crm-input" 
                type="date" 
                name="fecha_fin"
                [(ngModel)]="request.fecha_fin"
                required
                #fechaFin="ngModel">
                <div class="error-text" *ngIf="fechaFin.invalid && (fechaFin.dirty || fechaFin.touched)">
                  <small *ngIf="fechaFin.errors?.['required']"> El campo Fecha de cierre es obligatorio</small>
                </div>
            </div>
          </div>
      </div>

        <div class="d-flex justify-center gap-20 mt-5">
        <button type="button" class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
        @if(data.mode === 'edit'){
        <button type="button" class="btn btn-primary" (click)="updateMeta()" [disabled]="!GoalsForm.valid">Guardar cambios</button>
        }@else {
        <button type="button" class="btn btn-primary" (click)="createMeta()" [disabled]="!GoalsForm.valid">Crear nueva meta</button>
        }
      </div> 
      </form>  
</div>